export default function Bicycle({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 56 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {/* Frame */}
      <path
        d="M14 26 L26 12 L34 26 M26 12 L40 12 M22 26 L34 12"
        stroke="#0A0A0A"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Seat */}
      <path
        d="M22 12 L26 12"
        stroke="#0A0A0A"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Handlebar */}
      <path
        d="M38 9 L42 9 M40 9 L40 12"
        stroke="#0A0A0A"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      {/* Pedal */}
      <circle cx="26" cy="26" r="1.2" fill="#0A0A0A" />
      {/* Left wheel */}
      <g>
        <circle className="wheel" cx="14" cy="26" r="7" stroke="#0A0A0A" strokeWidth="1.2" fill="none" />
        <circle cx="14" cy="26" r="1.2" fill="#0A0A0A" />
      </g>
      {/* Right wheel */}
      <g>
        <circle className="wheel" cx="42" cy="26" r="7" stroke="#0A0A0A" strokeWidth="1.2" fill="none" />
        <circle cx="42" cy="26" r="1.2" fill="#0A0A0A" />
      </g>
    </svg>
  );
}
